/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Formatter_Deep_P1Inputs */

const en_formatter_deep_p1 = /** @type {(inputs: Formatter_Deep_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indentation is the only thing you asked to change, but a parse and re-serialize cycle normalizes numbers as a side effect. JSON has one numeric type and JavaScript reads it as a double, so the written form of a number is regenerated from its value rather than copied. The literal 1.0 comes back as 1, 1e3 becomes 1000, and 0.10 becomes 0.1. The numeric value is identical in every case, but the text is not byte for byte what you pasted.`)
};

const ko_formatter_deep_p1 = /** @type {(inputs: Formatter_Deep_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`바꾸라고 요청한 것은 들여쓰기뿐이지만, 파싱과 재직렬화 과정에서 숫자가 부수적으로 정규화됩니다. JSON의 숫자 타입은 하나이고 자바스크립트는 이를 double로 읽기 때문에, 숫자의 표기는 복사되는 것이 아니라 값으로부터 다시 생성됩니다. 리터럴 1.0은 1로, 1e3은 1000으로, 0.10은 0.1로 돌아옵니다. 모든 경우에 수치 자체는 같지만, 텍스트는 붙여넣은 것과 바이트 단위로 동일하지 않습니다.`)
};

const ja_formatter_deep_p1 = /** @type {(inputs: Formatter_Deep_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`変えるよう頼んだのはインデントだけですが、パースと再シリアライズの副作用として数値が正規化されます。JSON の数値型は 1 つで、JavaScript はこれを double として読むため、数値の表記はコピーされるのではなく値から再生成されます。リテラル 1.0 は 1 に、1e3 は 1000 に、0.10 は 0.1 になります。どの場合も数値そのものは同じですが、テキストは貼り付けたものとバイト単位で同一ではありません。`)
};

/**
* | output |
* | --- |
* | "Indentation is the only thing you asked to change, but a parse and re-serialize cycle normalizes numbers as a side effect. JSON has one numeric type and Java..." |
*
* @param {Formatter_Deep_P1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const formatter_deep_p1 = /** @type {((inputs?: Formatter_Deep_P1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Formatter_Deep_P1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_formatter_deep_p1(inputs)
	if (locale === "ko") return ko_formatter_deep_p1(inputs)
	return ja_formatter_deep_p1(inputs)
});